export const STOREFRONT_LAYOUT_IDS = [
  "grid",
  "grid2",
  "list",
  "list-collapse",
  "scroll",
  "bubbles",
  "jumbo",
];

const presetDefinitions = {
  grid: {
    name: "Grid",
    navigation: { pattern: "drill-down", controlStyle: "none" },
    card: {
      orientation: "vertical",
      density: "two-column",
      imagePlacement: "top",
    },
  },
  grid2: {
    name: "Grid minimal",
    navigation: { pattern: "drill-down", controlStyle: "none" },
    card: {
      orientation: "vertical",
      density: "two-column",
      imagePlacement: "top",
    },
  },
  list: {
    name: "List",
    navigation: { pattern: "inline-sections", controlStyle: "none" },
    card: {
      orientation: "horizontal",
      density: "single-column",
      imagePlacement: "start",
    },
  },
  "list-collapse": {
    name: "Collapse",
    navigation: {
      pattern: "inline-sections",
      controlStyle: "none",
      collapsible: true,
    },
    card: {
      orientation: "horizontal",
      density: "single-column",
      imagePlacement: "start",
    },
  },
  scroll: {
    name: "Scroll",
    navigation: { pattern: "inline-sections", controlStyle: "none" },
    card: {
      orientation: "vertical",
      density: "horizontal-rail",
      imagePlacement: "top",
    },
  },
  bubbles: {
    name: "Bubble",
    navigation: { pattern: "sticky", controlStyle: "bubbles" },
    card: {
      orientation: "vertical",
      density: "two-column",
      imagePlacement: "top",
    },
  },
  jumbo: {
    name: "Jumbo",
    navigation: { pattern: "inline-sections", controlStyle: "none" },
    card: {
      orientation: "horizontal",
      density: "single-column",
      imagePlacement: "end",
    },
  },
};

const categoryControlStyles = new Set(["none", "bubbles", "tags", "labels"]);

const normalizeCategoryControlStyle = (value, fallback) =>
  categoryControlStyles.has(value) ? value : fallback;

export const resolveStorefrontPreset = (settings = {}) => {
  const requestedId = settings.store_layout;
  const id = STOREFRONT_LAYOUT_IDS.includes(requestedId) ? requestedId : "scroll";
  const definition = presetDefinitions[id];
  const legacyCategoryStyle = normalizeCategoryControlStyle(
    settings.categories_layout,
    definition.navigation.controlStyle,
  );
  const isDrillDown = definition.navigation.pattern === "drill-down";
  const controlStyle = isDrillDown ? "none" : legacyCategoryStyle;
  const imagePlacement =
    id === "jumbo"
      ? settings.jumbo_direction === "ltr"
        ? "start"
        : "end"
      : definition.card.imagePlacement;
  const density =
    id === "bubbles" && settings.product_per_row
      ? "single-column"
      : definition.card.density;

  return {
    id,
    name: definition.name,
    fallbackApplied: id !== requestedId,
    navigation: {
      ...definition.navigation,
      controlStyle,
      sticky:
        controlStyle !== "none" && settings.categories_layout_sticky !== false,
      showAll: settings.hide_categories_layout_all !== true,
      collapsible: definition.navigation.collapsible === true,
      collapsedByDefault:
        definition.navigation.collapsible === true || id === "bubbles"
          ? settings.collapsed_by_default === true
          : false,
    },
    card: {
      ...definition.card,
      density,
      imagePlacement,
      hideCategoryOverlay:
        id === "grid" && settings.hide_grid_category_name === true,
    },
    legacy: {
      storeLayout: requestedId,
      categoriesLayout: settings.categories_layout,
    },
  };
};
